import type { QuizFeedbackProps } from '@/pages/pii-training/piiTraining.types';
import { Notification, NotificationDescription, NotificationIcon } from '@careflux/primitives';

/** Immediate right/wrong feedback, announced politely (role="status" instead of the default alert). */
export const QuizFeedback = ({ correct, message }: QuizFeedbackProps) => (
  // biome-ignore lint/a11y/useSemanticElements: Notification renders a div; role overrides its default "alert".
  <Notification role="status" variant={correct ? 'success' : 'error'}>
    <NotificationIcon />
    <NotificationDescription>{message}</NotificationDescription>
  </Notification>
);
